import { useCallback } from 'react'
import {
  getRecallReactivationControlReport,
  type RecallReactivationControlReportResult,
  type ReportBucketType,
} from '@services/api/reports/engagement.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type RecallReactivationControlData =
  RecallReactivationControlReportResult

export type UseRecallReactivationControlResult = {
  loading: boolean
  error: string | null
  data: RecallReactivationControlData | null
  bucketLabel: string
}

export function useRecallReactivationControl(
  toolbarSelection: Record<string, string>,
): UseRecallReactivationControlResult {
  const getBucketFromData = useCallback(
    (data: RecallReactivationControlReportResult): ReportBucketType =>
      data.recallComplianceTrend.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getRecallReactivationControlReport,
    getBucketFromData,
    errorMessage: 'Failed to load recall and reactivation data',
  })
}
